<template>
  <div class="l-container confirm-info mx-auto">
    
    <div class="top-title ml-2">
      <h3>お知らせ一覧</h3>
    </div>
    <div class="mt-6 mb-6 divider"></div>
    <div class="main-content flex">
      <div class="left-content m-4">
        <LeftNoti />
      </div>
      <div class="right-content">
        <div class="c-box m-4 pr-0">
          <div class="p-information">
              <div class="p-information__main">
                <div class="p-information__inner">
                  <div class="p-information__detail__inner">
                  <div class="p-information__detail__header">
                    <div class="p-information__detail__tags">
                      <p class="p-information__detail__date" v-if="detailInfo">
                          <!-- date YYYY年MM月DD日  -->
                          {{ formatDate(detailInfo.pub_date) }}
                      </p>
                      <p class="p-information__detail__tag" v-if="mainText[0]">
                          <!-- title -->
                          {{ mainText[0].attributes.name  }}
                      </p>
                    </div>
                    <div class="p-information__detail__sender" v-if="detailInfo" >
                       {{detailInfo.release_company}}
                    </div>
                  </div>
                <div class="p-information__detail__title" v-if="detailInfo">
                  <h3>{{detailInfo.display_title}}</h3>
                </div>
                <div 
                    class="p-information__detail__content"
                    v-if="mainText[2]"
                    v-html="mainText[2].attributes.field_text_data.value" />
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="back-to" >
          <div class="back-to_inner" @click="moveBack">
            <i class="icon icon-bor-arrow-left text-red-500 flex items-center pr-4"></i>
            <p>お知らせ一覧 に戻る</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LeftNoti from './components/LeftNoti'
import moment from 'moment'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import _ from 'lodash'

export default {
  name: 'BS_INF_01_001',
  components: {
    LeftNoti
  },
  data() {
    return {
      currentPage: 1,
      detailInfo: [],
      mainText: [],
      categoryWord: '',
      newsTypeId: '',
      year: '',
      controlPagination: {},
      isDisabledBtn: false,
      breadcrumbs: [],
      
      is_hidden: true,
      windowHeight: null,
      date: '2020.04.02',
      label: 'サービスについて',
      title: 'デジタルクーポンコード・デジタルチケットプランのご利用停止と再開目処について'
    }
  },

  methods: {
    async getDetail() {
      const { newsTypeId, year, Page } = this.$route.query
      const params = {
        newsTypeId,
        year,
        Page
      }
      const res = await this.$repositories('cms').getNewsId(this.$route.params.id, { params })
      this.detailInfo = res.data.detail.data[0].attributes
      this.mainText = res.data.detail.included
      this.breadcrumbs[this.breadcrumbs.length - 1].title = _.get(this.detailInfo, 'display_title', '')
      this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
    },
    formatDate(item) {
      return moment(item).format('YYYY.MM.DD')
    },
    /**
     * パンくずリスト作成
     */
    setBreadcrumb() {

    },
    moveBack() {
      this.$router.go(-1)
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  async mounted() {
    this.currentPage = 1
    this.year = this.$store.state.bs_inf.information.categoryYear
    this.newsTypeId = this.$store.state.bs_inf.information.categoryName
    this.getDetail()
  

    window.addEventListener('resize', () => {
      this.windowHeight = window.innerWidth
    })
  },
  watch: {
    $route() {
      this.setBreadcrumb()
      this.getList()
    },
    windowHeight () {
      if(this.windowHeight > 768) {
        this.is_hidden = true
      } else {
        this.is_hidden = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>